import React from 'react';
import {Layout, Row, Col, Skeleton} from 'antd';
import {BuscadorLateral} from './buscador-lateral';

const {Content, Sider} = Layout;

const LayoutBuscadorLateral = props =>{
    const {search, children} = props;
    const {onSearch, placeholder, loading, enterButton, onChange, items} = search;

    return (
        <Layout>
        <Sider width={300} theme="light" style={{background: "#FFF", height: "calc(100vh - 57px)"}}>            
            <BuscadorLateral
                search={{onSearch, placeholder,loading,enterButton,onChange}}
                items={
                    <Skeleton loading={loading} active={true}>{items}</Skeleton>}
            >                
            </BuscadorLateral>
        </Sider>
        <Layout >
            <Content style={{maxHeight: "calc(100vh - 190px)"}} >
                <Row>
                    <Col span='24' >
                    
                        
                        {children}

                    
                    </Col>
                </Row>

            </Content>
        </Layout>
        
    </Layout>
    )
}

export {LayoutBuscadorLateral}